import { createFileRoute } from '@tanstack/react-router'

import { LegalAssistancePage } from '../../../../components/pages/legal-assistance/legal-assistance-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/legal-assistance')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <LegalAssistancePage />
    </PermissionChecker>
  ),
})
